import { render, staticRenderFns } from "./CbsObjectMount.vue?vue&type=template&id=4cf773cc&scoped=true"
import script from "./CbsObjectMount.vue?vue&type=script&lang=js"
export * from "./CbsObjectMount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf773cc",
  null
  
)

export default component.exports